import React, { Component } from 'react';

class IconNotFound extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="57.051" height="51.855" viewBox="0 0 57.051 51.855">
                <g id="Group_8982" data-name="Group 8982" transform="translate(21459.585 19027)">
                    <path id="Path_6310" data-name="Path 6310" d="M52.8,59.388,33.925,26.694a8.032,8.032,0,0,0-13.952,0L1.086,59.388A8.069,8.069,0,0,0,8.062,71.5h37.7A8.111,8.111,0,0,0,52.8,59.388Z" transform="translate(-21458 -19048.143)" fill="#fd4c1e" stroke="#cb1814" strokeWidth="3" />
                    <path id="Icon_awesome-exclamation-circle" data-name="Icon awesome-exclamation-circle" d="M48.654,43.919a4.515,4.515,0,1,0,4.515,4.515A4.515,4.515,0,0,0,48.654,43.919ZM44.367,27.691,45.1,41.039a1.178,1.178,0,0,0,1.176,1.114h4.764a1.178,1.178,0,0,0,1.176-1.114l.728-13.347a1.178,1.178,0,0,0-1.176-1.242H45.543A1.178,1.178,0,0,0,44.367,27.691Z" transform="translate(-21479.715 -19038.449)" fill="#fff" />
                </g>
            </svg>
        );
    }
}

export default IconNotFound;